export type ProfilePhotoType = 'Photos' | 'Camera';

export enum ProfilePhotoTypeValues {
  Photos = 'Photos',
  Camera = 'Camera',
}
